import React from "react";
import { connect } from "react-redux";
import i18n from "../../../i18nextInitiator";
import { Grid, Typography } from "@material-ui/core";
import {
  removeInvoice,
  setDriver,
  getBill,
  formatPrice,
  getOrderStateId,
  bindingParamsToPath,
  paths,
} from "../../../actions/actionCreators";
import agent from "../../../agent";
import { withRouter, Link } from "react-router-dom";
import Skeleton from "@material-ui/lab/Skeleton";
import Divider from "../Divider";
import ShippingDetails from "../ShippingDetails";
import Invoice from "../Invoice";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { KeyboardArrowUp } from "@material-ui/icons";
import { SHOW_DELETE_ALERT } from "../../../actions/actionsTypes";
import withStyles from "@material-ui/core/styles/withStyles";
import { compose } from "redux";
import TopBox from "./TopBox";
import TrackerHoc from "./TrackerHoc";
import Button from "@material-ui/core/Button";
import TrackDriver from "./TrackDriver";

/**
 * The Specific translate function for this namespace
 * @type {TFunction}
 */
const t = i18n.getFixedT("fa", "general");

/**
 * Component Styles.
 * @type {(props?: any) => ClassNameMap<"address"|"submit"|"secPlateBox"|"plateBox"|"guarantee"|"box"|"label"|"avatar"|"title"|"paper"|"price"|"root"|"subtitle"|"plateIran">}
 */
const styles = (theme) => ({
  root: {
    padding: "20px 20px",
    maxWidth: 600,
    margin: "0 auto",
    "& > *": {
      margin: ".8rem 0",
    },
    "& button": {
      boxShadow: "unset",
    },
  },
  paper: {
    backgroundColor: theme.palette.primary.light,
    border: "solid 1px #a9aed0",
    padding: "1rem .5rem",
    width: "100%",
    boxShadow: "none",
  },
  label: {
    marginTop: ".5rem !important",
  },
  avatar: {
    height: 50,
    width: 50,
  },
  plateBox: {
    border: `solid 0.5px #adb5bd`,
    borderRadius: 2,
    backgroundColor: "#fff",
    padding: "0 .2rem",
  },
  secPlateBox: {
    "& > *": {
      padding: " .42rem .2rem",
    },
  },
  plateIran: {
    fontSize: ".6rem",
    textAlign: "center",
  },
  box: {
    "& *": {
      margin: ".15rem 0",
    },
  },
  title: {
    fontSize: "18px",
    fontWeight: 400,
    color: theme.palette.primary.main,
  },
  subtitle: {
    fontWeight: 600,
  },
  price: {
    textAlign: "right",
    fontSize: "20px",
    fontWeight: 900,
  },
  guarantee: {
    color: theme.palette.success.main,
  },
  address: {
    fontWeight: 500,
  },
  submit: {
    fontSize: 20,
  },
});

/**
 * Redux States.
 * @param state
 */
const mapStateToProps = (state) => ({ ...state.invoice });

/**
 * redux dispatcher.
 * @param dispatch
 * @returns {{getBill: getBill, removeInvoice: removeInvoice, setDriver: setDriver, showCancelWarn: showCancelWarn}}
 */
const mapDispatchToProps = (dispatch) => ({
  removeInvoice,
  setDriver,
  showCancelWarn: () => {
    dispatch({ type: SHOW_DELETE_ALERT, message: t("cancel-question") });
  },
});

class Tracker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      seeInvoiceDetails: false,
      status: props.bill && props.bill.status,
    };
  }

  componentWillUnmount() {
    const {
      props,
      state: { getBillInterval },
    } = this;
    clearInterval(getBillInterval);
    props.removeInvoice();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      retrieveDriver,
      props: { bill: { order: { status: statusAfter = {} } = {} } = {} },
    } = this;
    const { bill: { order: { status: statusBefore = {} } = {} } = {} } =
      prevProps;

    if (
      statusBefore !== statusAfter &&
      statusAfter > getOrderStateId("submitted")
    )
      retrieveDriver();
  }

  retrieveDriver = () => {
    const {
      props,
      state: { id },
    } = this;
    agent.Invoice.driver(id).then((res) => {
      if (res && res.status === 200) props.setDriver(res.data);
    });
  };

  /**
   * sets new value for seeInvoiceDetails state.
   * @param value
   */
  setSeeInvoiceDetails = (value) => this.setState({ seeInvoiceDetails: value });

  /**
   * Toggles the display of invoice details
   */
  toggleInvoiceDetails = () => {
    const {
      state: { seeInvoiceDetails },
      setSeeInvoiceDetails,
    } = this;

    seeInvoiceDetails
      ? setSeeInvoiceDetails(false)
      : setSeeInvoiceDetails(true);
  };

  render() {
    const {
      props,
      props: {
        classes,
        bill: { id, driver, workers, name, phone, status = {} } = {},
      } = {},
      state: { seeInvoiceDetails },
      toggleInvoiceDetails,
    } = this || {};
    return (
      <div className={classes.root}>
        <TopBox
          id={id}
          status={status}
          cancel={props.showCancelWarn}
          driver={driver}
          workers={workers}
        />

        <Grid>
          <Typography>{t("invoice.paying-price")}:</Typography>
          <Grid container justifyContent="space-between">
            <Grid item>
              {props.bill ? (
                <Typography variant={props.bill.price ? "h6" : "body1"}>
                  {props.bill.price
                    ? formatPrice(props.bill.price)
                    : t("invoice.will-call-you")}
                </Typography>
              ) : (
                <Skeleton />
              )}
            </Grid>

            <Grid item style={{ margin: "auto 0" }}>
              <Typography
                color="primary"
                variant="body2"
                onClick={toggleInvoiceDetails}
              >
                {(seeInvoiceDetails ? t("close") : t("see")) +
                  " " +
                  t("invoice.details-title")}
                {seeInvoiceDetails ? (
                  <KeyboardArrowUp />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </Typography>
            </Grid>
          </Grid>
          {seeInvoiceDetails && <Invoice />}
        </Grid>

        <Divider />
        <TrackDriver />
        <ShippingDetails />
        <Divider />

        <Grid className={classes.box} container>
          <Grid justifyContent={"space-between"} container>
            <Typography color={"primary"}>{t("invoice.id")}</Typography>
            <Typography>{id || <Skeleton />}</Typography>
          </Grid>
          <Grid justifyContent={"space-between"} container>
            <Typography color={"primary"}>
              {t("invoice.receiver-name")}
            </Typography>
            <Typography>{name || <Skeleton />}</Typography>
          </Grid>
          <Grid justifyContent={"space-between"} container>
            <Typography color={"primary"}>
              {t("invoice.receiver-phone")}
            </Typography>
            <Typography>{phone || <Skeleton />}</Typography>
          </Grid>
        </Grid>

        {status === getOrderStateId("payed") &&
          status !== getOrderStateId("cancelled") && (
            <Grid justifyContent={"center"} container>
              <Grid item>
                <Link to={bindingParamsToPath(id, paths.representative_invoice)}>
                <Button
                  variant={"text"}
                  target="_blank"
                  // href={bindingParamsToPath(id, paths.representative_invoice)}
                >
                  {t("invoice.representative-btn")}
                </Button>
                </Link>
              </Grid>
            </Grid>
          )}
      </div>
    );
  }
}

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
  TrackerHoc
)(Tracker);
